import Input from "components/Elements/Inputv2";
import React, { FC } from "react";
import { SendingServiceSettingsProps } from "../SmsSettings";

const MesgatSettings: FC<SendingServiceSettingsProps> = ({
  formData,
  setFormData,
}) => {
  return (
    <div className="p-5 flex justify-center font-inter text-[14px] font-normal leading-[22px] text-[#111827]">
      <div className="max-w-[970px] w-full flex flex-col gap-5">
        <div className="bg-white p-5 flex flex-col gap-5">
          <div className="flex flex-col gap-[5px]">
            <div>Msegat Api Key</div>
            <Input
              id="twilio-account-sid-input"
              wrapperClassName="!w-full"
              className="w-full"
              value={formData.msegatApiKey}
              onChange={(value) =>
                setFormData({ ...formData, msegatApiKey: value })
              }
              placeholder="Msegat Api Key"
            />
          </div>

          <div className="flex flex-col gap-[5px]">
            <div>Msegat User Name</div>
            <Input
              id="twilio-auth-token-input"
              wrapperClassName="!w-full"
              className="w-full"
              value={formData.msegatUserName}
              onChange={(value) =>
                setFormData({ ...formData, msegatUserName: value })
              }
              placeholder="Msegat User Name"
            />
          </div>

          <div className="flex flex-col gap-[5px]">
            <div>Msegat User Sender </div>
            <Input
              id="twilio-auth-token-input"
              wrapperClassName="!w-full"
              className="w-full"
              value={formData.msegatUserSender}
              onChange={(value) =>
                setFormData({ ...formData, msegatUserSender: value })
              }
              placeholder="Msegat User Sender"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MesgatSettings;
